export const getCurrentPageName = () => {
  let pageName = window.location.pathname.replace("/dashboard/", "");

  return pageName.toUpperCase();
};
